module.exports = __webpack_public_path__ + "img/40.a4efc6a2.png";